import { forwardRef } from 'react';
import { InputAdornment } from '@mui/material';

import { Icon, Icons } from 'Icon';
import { TextField } from 'TextField';

import { SearchFieldProps, SearchOptions } from './SearchField.types';
import { SearchFieldStyled, StyledOptions } from './SearchField.styled';

export const SearchField = forwardRef<unknown, SearchFieldProps>(
  ({ fullWidth, label, options, placeholder, ...props }: SearchFieldProps, ref) => {
    return (
      <SearchFieldStyled
        clearIcon={<Icon icon={Icons.removeSolid} />}
        componentsProps={{
          paper: {
            sx: {
              boxShadow: '0px 4px 8px rgba(34, 38, 72, 0.32)',
            },
          },
        }}
        fullWidth={fullWidth}
        options={options}
        ref={ref}
        renderInput={(params) => (
          <TextField
            {...params}
            InputLabelProps={
              props?.hiddenLabel
                ? { ...params.InputLabelProps, className: 'sr-only' }
                : params.InputLabelProps
            }
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <Icon icon={Icons.search} />
                </InputAdornment>
              ),
            }}
            fullWidth={fullWidth}
            label={label}
            placeholder={placeholder}
          />
        )}
        renderOption={(optionProps, option: SearchOptions) => {
          return (
            <StyledOptions {...optionProps}>
              {typeof option === 'string'
                ? option
                : props.getOptionLabel
                ? props.getOptionLabel(option)
                : option.label}
            </StyledOptions>
          );
        }}
        {...props}
      />
    );
  },
);

SearchField.displayName = 'SearchField';
